<template>
  <div class="camera-wrap"
    ref="cameraWrap">
    <camera
      class="camera"
      ref="cameraMonitor"
      :video-width="videoWidth"
      :video-height="videoHeight"
      :photo-width="photoWidth"
      :photo-height="photoHeight"
      :upload-path="uploadPath"
      @handleError="handleError"
      @photoReport="photoReport"
    ></camera>
  </div>
</template>

<script>
import Camera from '@/views/components/OpenCamera'
export default {
  components: {
    Camera
  },
  props: {
    openPhotoMonitor: {
      type: Boolean
    }
  },
  data() {
    return {
      videoWidth: 240,
      videoHeight: 160,
      photoWidth: 420,
      photoHeight: 280,
      photoTimer: null,
      uploadPath: ''
    }
  },
  watch: {
    openPhotoMonitor(val) {
      if (val) {
        this.photoTimer = setInterval(() => {
          this.$refs.cameraMonitor.setImage() // 一分钟拍照一次
        }, 60000)
      } else {
        clearInterval(this.photoTimer)
        this.photoTimer = null
      }
    }
  },
  mounted() {
    this.uploadPath = `test/monitorPhoto/${localStorage.examId}`
    this.$refs.cameraMonitor.getCompetence()
    if (this.openPhotoMonitor) { // 打开AI监控拍照
      this.photoTimer = setInterval(() => {
        this.$refs.cameraMonitor.setImage() // 一分钟拍照一次
      }, 60000)
    }
  },
  methods: {
    closeVideo() {
      if (this.$refs.cameraMonitor) {
        this.$refs.cameraMonitor.stopNavigator()
      }
    },
    handleError(type) {
      this.$emit('cameraError', type)
    },
    photoReport(url) {
      this.$emit('photoReport', url)
    }
  },
  destroyed() {
    this.closeVideo()
    clearInterval(this.photoTimer)
    this.photoTimer = null
  }
}
</script>

<style lang="scss" scoped>
  .camera-wrap {
    position: relative;
    background-color: #E3E3E3;
    width: 240px;
    height: 160px;
    border-radius: 8px;
  }
  .camera {
    /deep/ video {
      border-radius: 8px;
    }
  }
</style>
